import { SET_CURRENTLY_DISPLAYED_USERS } from '@store/action-list'

/**
 * State is a list of paginated users on the current screen
 */
export default (state = { totalRows: 0, users: [] }, action) => {
  switch (action.type) {
    case SET_CURRENTLY_DISPLAYED_USERS: {
      const { total_rows: totalRows, users } = action.payload
      console.log(
        `Redux: Setting CurrentlyDisplayedUsers to ${users.length} users`,
      )
      return { totalRows, users }
    }
    default:
      return state
  }
}
